module.exports = ({"version":"v3.238.5","revision":"47df2d3b9390ea61159477d50a400f7aed21e77f","applicationMode":"prod","environmentMode":"saas"})